import React, { Component } from "react"
import { Button, Container } from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import "./footer.scss"
import { SocketMenu } from "./SocketMenu";

class Footer extends Component {
  
  handleBackToTop = () => {
    window.scrollTo( 0, 0 )
  }
  
  render() {
    return (
      <footer className="footer relative ">
        
        <Container>
          <div className="absolute right-1 top-1">
            <BackToTop onClick={this.handleBackToTop}/>
          </div>
          <div className="pt4 pb5">
            <WordPressContainer postType="shop" slug="footer"/>
          </div>
        
        
        </Container>
        
        <SocketMenu/>
      </footer>
    )
  }
}

const BackToTop = ( { onClick } ) => {
  return (
    <div className="pt3"><Button   basic onClick={onClick} icon={"chevron up"}/></div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/theme/base/components/Footer/Footer.js